

export const iniciarChatWass = ({nombre='', numero, nombreFunnel=''}) =>{
    let texto = encodeURI('Hola '+ nombre + ' quiero saber mas de ' + nombreFunnel);
    let link = `https://api.whatsapp.com/send?phone=${numero}&text=${texto}`
    window.open(link)
}